import { render, staticRenderFns } from "./aviso_privacidad.vue?vue&type=template&id=d57dadb2"
import script from "./aviso_privacidad.vue?vue&type=script&lang=js"
export * from "./aviso_privacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports